import { FaRobot, FaCloud, FaLayerGroup, FaBrain, FaLock, FaUsers, FaChartPie } from 'react-icons/fa6';

const whyChooseUs = {
    sub: "Why Choose Us",
    heading: "Empowering Your Business with AI",
    content: "We provide innovative AI-powered solutions designed to optimize workflows, and accelerate your business growth. Our expertise helps you stay ahead in a rapidly evolving landscape.",
    points: [
        {
            id: 1,
            icon: <FaRobot />, // Robot icon
            title: 'AI-Powered Automation',
        },
        {
            id: 2,
            icon: <FaRobot />, // Robot icon
            title: 'AI-Powered Automation',
        },
        {
            id: 3,
            icon: <FaCloud />, // Cloud icon
            title: 'Cloud Integration',
        },
        {
            id: 4,
            icon: <FaLayerGroup />, // Infrastructure icon
            title: 'Scalable Infrastructure',
        },
        {
            id: 5,
            icon: <FaBrain />, // Brain icon
            title: 'Custom AI Models',
        },
        {
            id: 6,
            icon: <FaLock />, // Lock icon
            title: 'End-to-End Security',
        },
        {
            id: 7,
            icon: <FaUsers />, // Users icon
            title: 'Collaboration Tools',
        },
        {
            id: 8,
            icon: <FaUsers />, // Users icon (for API Access)
            title: 'Advanced API Access',
        },
        {
            id: 9,
            icon: <FaChartPie />, // Chart Pie icon
            title: 'Insightful Dashboards',
        },
    ]
}

export default whyChooseUs;